
import { canv } from '@/canv/global.js'
import { drawRoundedRect, isOverRect, generateUID } from '@/canv/utils.js'
import { textWidget } from '@/elements/text/text.js'




export class mindMapWidgetInterface {

    constructor(mindMapWidget) {
        this.mindMapWidget = mindMapWidget;

        let addChildMacOs = new Image();
        addChildMacOs.src = `https://${canv.getInitDataProp('appDomain')}/api/v2/static/media/system/mindMapShortcut1.svg`;

        let addNeighbourMacOs = new Image();
        addNeighbourMacOs.src = `https://${canv.getInitDataProp('appDomain')}/api/v2/static/media/system/mindMapShortcut2.svg`;

        let addChildWindows = new Image();
        addChildWindows.src = `https://${canv.getInitDataProp('appDomain')}/api/v2/static/media/system/mindMapShortcut5.svg`;

        let addNeighbourWindows = new Image();
        addNeighbourWindows.src = `https://${canv.getInitDataProp('appDomain')}/api/v2/static/media/system/mindMapShortcut7.svg`;

        this.shortcutIcons = {
            "addChildMacOs": {
                "icon": addChildMacOs,
                "ratio": 2
            },
            "addNeighbourMacOs": {
                "icon": addNeighbourMacOs,
                "ratio": 3
            },
            "addChildWindows": {
                "icon": addChildWindows,
                "ratio": 2
            },
            "addNeighbourWindows": {
                "icon": addNeighbourWindows,
                "ratio": 3
            }
        }
    }





    getAddActionInfo() {
        let nothing = [];

        if (this.mindMapWidget.interactionType == "") return nothing;
        if (this.mindMapWidget.selected.length != 1) return nothing;

        if (this.mindMapWidget.interactionType == "fly") return nothing;

        let node = this.mindMapWidget.getOnlySelectedNode();

        if (node.textPart.isOnlyEmptyLine()) return nothing;

        let padding = canv.actionManager.getZoomConstant(10);
        let size = canv.actionManager.getZoomConstant(28);

        if (size > 2*node.height) return nothing;

        let result = [];

        if (this.mindMapWidget.directionMode == "horizontal") {

            if (node.parentNodeUID == "") {
                result.push({
                    "startX": node.startX + node.width + padding,
                    "startY": node.startY + node.height/2 - size/2,
                    "width": size,
                    "height": size,
                    "type": "child",
                    "direction": "direct",
                });
                result.push({
                    "startX": node.startX - padding - size,
                    "startY": node.startY + node.height/2 - size/2,
                    "width": size,
                    "height": size,
                    "type": "child",
                    "direction": "reverse",
                });
            } else {

                if (node.direction == "direct") {
                    result.push({
                        "startX": node.startX + node.width + padding,
                        "startY": node.startY + node.height/2 - size/2,
                        "width": size,
                        "height": size,
                        "type": "child",
                        "direction": "direct" // before | after
                    });
                } else {
                    result.push({
                        "startX": node.startX - padding - size,
                        "startY": node.startY + node.height/2 - size/2,
                        "width": size,
                        "height": size,
                        "type": "child",
                        "direction": "reverse" // before | after
                    });
                }

                result.push({
                    "startX": node.startX + node.width/2 - size/2,
                    "startY": node.startY + node.height + padding,
                    "width": size,
                    "height": size,
                    "type": "neighbour",
                    "direction": node.direction,
                    "side": "after",
                });
            }

        } else {
            if (node.parentNodeUID == "") {
                result.push({
                    "startX": node.startX + node.width/2 - size/2,
                    "startY": node.startY + node.height + padding,
                    "width": size,
                    "height": size,
                    "type": "child",
                    "direction": "direct",
                });
                result.push({
                    "startX": node.startX + node.width/2 - size/2,
                    "startY": node.startY - padding - size,
                    "width": size,
                    "height": size,
                    "type": "child",
                    "direction": "reverse",
                });
            } else {

                if (node.direction == "direct") {
                    result.push({
                        "startX": node.startX + node.width/2 - size/2,
                        "startY": node.startY + node.height + padding,
                        "width": size,
                        "height": size,
                        "type": "child",
                        "direction": "direct" // before | after
                    });
                } else {
                    result.push({
                        "startX": node.startX + node.width/2 - size/2,
                        "startY": node.startY - padding - size,
                        "width": size,
                        "height": size,
                        "type": "child",
                        "direction": "reverse" // before | after
                    });
                }

                result.push({
                    "startX": node.startX + node.width + padding,
                    "startY": node.startY + node.height/2 - size/2,
                    "width": size,
                    "height": size,
                    "type": "neighbour",
                    "direction": node.direction,
                    "side": "after",
                });
                result.push({
                    "startX": node.startX - padding - size,
                    "startY": node.startY + node.height/2 - size/2,
                    "width": size,
                    "height": size,
                    "type": "neighbour",
                    "direction": node.direction,
                    "side": "before",
                });
            }
        }

        return result;
    }

    isAction() {

        let buttons = this.getAddActionInfo();

        for (let i = 0; i < buttons.length; i++) {
            let props = buttons[i];
            if (isOverRect(props["startX"], props["startY"], props["width"], props["height"])) {
                return {
                    "status": true,
                    "data": props
                }
            }
        }

        return {
            "status": false
        }

    }

    resertDrawRatio() {
        this.drawRatio = 0;
        this.shortcutData = null;
        clearTimeout(this.shortcutTimer);
        this.shortcutTimer = null;
    }



    TryAction(type) {
        if (type == "keyboardDown" || type == "touchpadGestureDragging" || type == "touchpadGestureZoom") {
            this.resetShortcutData();
        }
    }


    // shortcuts

    checkShortcut() {
        let buttons = this.getAddActionInfo();
        for (let i = 0; i < buttons.length; i++) {
            let button = buttons[i];
            if (isOverRect(button["startX"], button["startY"], button["width"], button["height"])) {
                this.shortcutData = {
                    "draw": false,
                    "button": button
                };
                this.shortcutTimer = setTimeout(this.approveShortcut.bind(this), 450);
            }
        }
    }

    approveShortcut() {
        if (this.shortcutData != null) {
            this.shortcutData["draw"] = true;
            canv.redraw();
        }
    }

    resetShortcutData() {
        this.shortcutData = null;
        clearTimeout(this.shortcutTimer);
        this.shortcutTimer = null;
        canv.redraw();
    }

    drawShortcut() {
        if (this.shortcutData == null || !this.shortcutData["draw"]) return;

        let buttonData = this.shortcutData["button"];

        var fontSize = canv.actionManager.getZoomConstant(15);
        var margin = canv.actionManager.getZoomConstant(11);

        let iconData = this.shortcutIcons["addChildMacOs"];

        let shortcutText = "";
        if (buttonData["type"] == "child") {
            shortcutText = "Cледующий узел";
            if (canv.actionManager.os == "MacOS") {
                iconData = this.shortcutIcons["addChildMacOs"];
            } else {
                iconData = this.shortcutIcons["addChildWindows"];
            }
        } else {
            if (buttonData["side"] == "before")  return; // shortcut работает для after

            shortcutText = "Cоседний узел";
            if (canv.actionManager.os == "MacOS") {
                iconData = this.shortcutIcons["addNeighbourMacOs"];
            } else {
                iconData = this.shortcutIcons["addNeighbourWindows"];
            }
        }


        canv.ctx.font = fontSize.toString() + "px Spoof";
        var metrics = canv.ctx.measureText(shortcutText);
        let titleHeight = metrics.actualBoundingBoxAscent; //+ metrics.actualBoundingBoxDescent;
        let titleWidth = metrics.width;

        // titleHeight = canv.actionManager.getZoomConstant(20);
        // titleWidth = 3*canv.actionManager.getZoomConstant(20);


        let iconHeight = titleHeight + margin/2;
        let iconWidth = iconHeight * iconData["ratio"];

        let shortcutHeight = titleHeight + 2*margin;
        let shortcutWidth = titleWidth + iconWidth + 3*margin;

        let gap = canv.actionManager.getZoomConstant(10);
        let arrowBoxWidth = canv.actionManager.getZoomConstant(7);
        let arrowBoxHeight = canv.actionManager.getZoomConstant(10);

        // рисуем стрелку
        canv.ctx.beginPath();
        canv.ctx.moveTo(buttonData["startX"] + buttonData["width"] + arrowBoxWidth + gap, buttonData["startY"] + buttonData["height"]/2 + arrowBoxHeight/2);
        canv.ctx.lineTo(buttonData["startX"] + buttonData["width"] + gap, buttonData["startY"] + buttonData["height"]/2);
        canv.ctx.lineTo(buttonData["startX"] + buttonData["width"] + arrowBoxWidth + gap, buttonData["startY"] + buttonData["height"]/2 - arrowBoxHeight/2);
        canv.ctx.fillStyle = "#1E1E1E";
        canv.ctx.fill();


        // рисуем box
        drawRoundedRect(buttonData["startX"] + buttonData["width"] + arrowBoxWidth + gap, buttonData["startY"] + buttonData["height"]/2 - shortcutHeight/2, shortcutWidth, shortcutHeight, shortcutHeight/15);
        canv.ctx.fillStyle = "#1E1E1E";
        canv.ctx.fill();

        // рисуем текст
        let textStartX =  buttonData["startX"] + buttonData["width"] + arrowBoxWidth + gap + margin;
        canv.ctx.fillStyle = "white";
        canv.ctx.fillText(shortcutText, textStartX, buttonData["startY"] + buttonData["height"]/2 + titleHeight/2);

        let iconStartX =  buttonData["startX"] + buttonData["width"] + arrowBoxWidth + gap + margin + titleWidth + margin;
        canv.ctx.drawImage(iconData["icon"], iconStartX, buttonData["startY"] + buttonData["height"]/2 - iconHeight/2, iconWidth, iconHeight);


    }




    // draw

    draw() {

        let buttons = this.getAddActionInfo();

        if (buttons.length == 0) this.resertDrawRatio();

        if (this.shortcutData == null) {
            this.checkShortcut();
        } else {
            let buttonData = this.shortcutData["button"];
            if (!isOverRect(buttonData["startX"], buttonData["startY"], buttonData["width"], buttonData["height"])) {
                this.resetShortcutData();
            }
        }

        for (let i = 0; i < buttons.length; i++) {
            let props = buttons[i];

            let centerX = props["startX"] + props["width"] / 2;
            let centerY = props["startY"] + props["height"] / 2;

            let currentWidth =  props["width"] * this.drawRatio;
            let currentHeight =  props["height"] * this.drawRatio;

            let modifiedStartX = centerX - currentWidth/2;
            let modifiedStartY = centerY - currentHeight/2;

            drawRoundedRect(modifiedStartX, modifiedStartY, currentWidth, currentHeight, 10 * currentWidth);

            if (this.drawRatio < 1) {
                this.drawRatio += 0.05;
                canv.redraw();
            }

            canv.ctx.strokeStyle = "#0B99FF";
            canv.ctx.fillStyle = "#FFFFFF";
            if (isOverRect(props["startX"], props["startY"], props["width"], props["height"])) {
                canv.ctx.fillStyle = "#0B99FF";
            }
            canv.ctx.lineWidth = canv.actionManager.getZoomConstant(4);
            canv.ctx.stroke();
            canv.ctx.fill();

            if (props["type"] == "child") {
                this.drawChildAction(props["startX"], props["startY"], props["width"], props["height"], props["direction"]);
            } else {
                if (this.mindMapWidget.directionMode == "horizontal") {
                    if (props["direction"] == "direct") {
                        this.drawNeighbourActionHorizontalDirect(props["startX"], props["startY"], props["width"], props["height"]);
                    } else {
                        this.drawNeighbourActionHorizontalReverse(props["startX"], props["startY"], props["width"], props["height"]);
                    }
                } else
                if (props["direction"] == "direct") {
                    this.drawNeighbourActionVerticalDirect(props["startX"], props["startY"], props["width"], props["height"], props["side"]);
                } else {
                    this.drawNeighbourActionVerticalReverse(props["startX"], props["startY"], props["width"], props["height"], props["side"]);
                }
            }
        }

        this.drawShortcut();
    }


    // draw actions

    // child
    drawChildAction(startX, startY, width, height, direction) {


        canv.ctx.fillStyle = "#0B99FF";
        if (isOverRect(startX, startY, width, height)) {
            canv.ctx.fillStyle = "#FFFFFF";
        }

        if (this.mindMapWidget.directionMode == "horizontal") {

            let handleWidth = 0.25 * width;
            let handleHeight = 0.1 * height;
            let bodyWidth = 0.3 * width;
            let bodyHeight = 0.25 * height;

            let actionStartX = startX + width/2 - (handleWidth + bodyWidth)/2;

            if (direction == "direct") {
                drawRoundedRect(actionStartX, startY + height/2 - handleHeight/2, handleWidth, handleHeight, handleHeight/10);
                canv.ctx.fill();

                drawRoundedRect(actionStartX + handleWidth, startY + height/2 - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
                canv.ctx.fill();
            } else {
                drawRoundedRect(actionStartX, startY + height/2 - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
                canv.ctx.fill();

                drawRoundedRect(actionStartX + bodyWidth, startY + height/2 - handleHeight/2, handleWidth, handleHeight, handleHeight/10);
                canv.ctx.fill();
            }
        } else {

            let handleHeight = 0.25 * width;
            let handleWidth = 0.1 * height;
            let bodyHeight = 0.3 * width;
            let bodyWidth = 0.25 * height;

            let actionStartY = startY + height/2 - (handleHeight + bodyHeight)/2;

            if (direction == "direct") {
                drawRoundedRect(startX + width/2 - handleWidth/2, actionStartY, handleWidth, handleHeight, handleHeight/10);
                canv.ctx.fill();

                drawRoundedRect(startX + width/2 - bodyWidth/2, actionStartY + handleHeight, bodyWidth, bodyHeight, bodyHeight/10);
                canv.ctx.fill();
            } else {
                drawRoundedRect(startX + width/2 - bodyWidth/2, actionStartY, bodyWidth, bodyHeight, bodyHeight/10);
                canv.ctx.fill();

                drawRoundedRect(startX + width/2 - handleWidth/2, actionStartY + bodyHeight, handleWidth, handleHeight, handleHeight/10);
                canv.ctx.fill();
            }
        }



    }

    // horizontal
    drawNeighbourActionHorizontalDirect(startX, startY, width, height) {
        let handleWidth = 0.25 * width;
        let handleHeight = 0.1 * height;
        let bodyWidth = 0.3 * width;
        let bodyHeight = 0.25 * height;

        let padding = 0.1 * height;

        let actionStartX = startX + width/2 - (handleWidth + bodyWidth)/2;
        let topCenterY = startY + height/2 - padding/2 - bodyHeight/2;
        let bottomCenterY = startY + height/2 + padding/2 + bodyHeight/2;

        canv.ctx.fillStyle = "#BCE3FF";

        drawRoundedRect(actionStartX, topCenterY - handleHeight/2, handleWidth, handleHeight, handleHeight/10);
        canv.ctx.fill();
        drawRoundedRect(actionStartX + handleWidth, topCenterY - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();

        canv.ctx.fillStyle = "#0B99FF";
        canv.ctx.strokeStyle = "#0B99FF";
        if (isOverRect(startX, startY, width, height)) {
            canv.ctx.fillStyle = "#FFFFFF";
            canv.ctx.strokeStyle = "#FFFFFF";
        }
        canv.ctx.lineWidth = handleHeight;

        canv.ctx.beginPath();
        canv.ctx.moveTo(actionStartX, topCenterY);
        canv.ctx.bezierCurveTo(actionStartX + handleWidth, topCenterY, actionStartX, bottomCenterY, actionStartX + handleWidth, bottomCenterY)
        canv.ctx.stroke();
        canv.ctx.closePath();

        drawRoundedRect(actionStartX + handleWidth, bottomCenterY - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();
    }

    drawNeighbourActionHorizontalReverse(startX, startY, width, height) {
        let handleWidth = 0.25 * width;
        let handleHeight = 0.1 * height;
        let bodyWidth = 0.3 * width;
        let bodyHeight = 0.22 * height;

        let padding = 0.1 * height;

        let actionStartX = startX + width/2 + (handleWidth + bodyWidth)/2;
        let topCenterY = startY + height/2 - padding/2 - bodyHeight/2;
        let bottomCenterY = startY + height/2 + padding/2 + bodyHeight/2;

        canv.ctx.fillStyle = "#BCE3FF";

        drawRoundedRect(actionStartX - handleWidth, topCenterY - handleHeight/2, handleWidth, handleHeight, handleHeight/10);
        canv.ctx.fill();
        drawRoundedRect(actionStartX - handleWidth - bodyWidth, topCenterY - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();

        canv.ctx.fillStyle = "#0B99FF";
        canv.ctx.strokeStyle = "#0B99FF";
        if (isOverRect(startX, startY, width, height)) {
            canv.ctx.fillStyle = "#FFFFFF";
            canv.ctx.strokeStyle = "#FFFFFF";
        }
        canv.ctx.lineWidth = handleHeight;

        canv.ctx.beginPath();
        canv.ctx.moveTo(actionStartX, topCenterY);
        canv.ctx.bezierCurveTo(actionStartX - handleWidth, topCenterY, actionStartX, bottomCenterY, actionStartX - handleWidth, bottomCenterY)
        canv.ctx.stroke();
        canv.ctx.closePath();

        drawRoundedRect(actionStartX - handleWidth - bodyWidth, bottomCenterY - bodyHeight/2, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();
    }

    //vertical
    drawNeighbourActionVerticalDirect(startX, startY, width, height, side) {
        let handleHeight = 0.25 * width;
        let handleWidth = 0.1 * height;
        let bodyHeight = 0.3 * width;
        let bodyWidth = 0.22 * height;

        let padding = 0.1 * height;

        let actionStartY = startY + height/2 - (handleHeight + bodyHeight)/2;
        let leftCenterX = startX + width/2 - padding/2 - bodyWidth/2;
        let rightCenterX = startX + width/2 + padding/2 + bodyWidth/2;

        if (side == "before") {
            rightCenterX = startX + width/2 - padding/2 - bodyWidth/2;
            leftCenterX = startX + width/2 + padding/2 + bodyWidth/2;
        }

        canv.ctx.fillStyle = "#BCE3FF";

        drawRoundedRect(leftCenterX - handleWidth/2, actionStartY, handleWidth, handleHeight, handleHeight/10);
        canv.ctx.fill();
        drawRoundedRect(leftCenterX - bodyWidth/2, actionStartY + handleHeight, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();

        canv.ctx.fillStyle = "#0B99FF";
        canv.ctx.strokeStyle = "#0B99FF";
        if (isOverRect(startX, startY, width, height)) {
            canv.ctx.fillStyle = "#FFFFFF";
            canv.ctx.strokeStyle = "#FFFFFF";
        }
        canv.ctx.lineWidth = handleWidth;

        canv.ctx.beginPath();
        canv.ctx.moveTo(leftCenterX, actionStartY);
        canv.ctx.bezierCurveTo(leftCenterX, actionStartY + handleHeight, rightCenterX, actionStartY, rightCenterX, actionStartY + handleHeight)
        canv.ctx.stroke();
        canv.ctx.closePath();

        drawRoundedRect(rightCenterX - bodyWidth/2, actionStartY + handleHeight, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();
    }

    drawNeighbourActionVerticalReverse(startX, startY, width, height, side) {
        let handleHeight = 0.25 * width;
        let handleWidth = 0.1 * height;
        let bodyHeight = 0.3 * width;
        let bodyWidth = 0.22 * height;

        let padding = 0.1 * height;

        let actionStartY = startY + height/2 - (handleHeight + bodyHeight)/2;
        let leftCenterX = startX + width/2 - padding/2 - bodyWidth/2;
        let rightCenterX = startX + width/2 + padding/2 + bodyWidth/2;

        if (side == "before") {
            rightCenterX = startX + width/2 - padding/2 - bodyWidth/2;
            leftCenterX = startX + width/2 + padding/2 + bodyWidth/2;
        }

        canv.ctx.fillStyle = "#BCE3FF";

        drawRoundedRect(leftCenterX - bodyWidth/2, actionStartY, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();
        drawRoundedRect(leftCenterX - handleWidth/2, actionStartY + bodyHeight, handleWidth, handleHeight, handleHeight/10);
        canv.ctx.fill();


        canv.ctx.fillStyle = "#0B99FF";
        canv.ctx.strokeStyle = "#0B99FF";
        if (isOverRect(startX, startY, width, height)) {
            canv.ctx.fillStyle = "#FFFFFF";
            canv.ctx.strokeStyle = "#FFFFFF";
        }
        canv.ctx.lineWidth = handleWidth;

        canv.ctx.beginPath();
        canv.ctx.moveTo(leftCenterX, actionStartY + bodyHeight + handleHeight);
        canv.ctx.bezierCurveTo(leftCenterX, actionStartY + bodyHeight, rightCenterX, actionStartY + bodyHeight + handleHeight, rightCenterX, actionStartY + bodyHeight)
        canv.ctx.stroke();
        canv.ctx.closePath();

        drawRoundedRect(rightCenterX - bodyWidth/2, actionStartY, bodyWidth, bodyHeight, bodyHeight/10);
        canv.ctx.fill();
    }


    mindMapWidget = null;
    drawRatio = 0;

    shortcutData = null;
    shortcutTimer = null;
}











